<template>
  <div class="footer-wrapper">
    <div class="mailing" v-if="this.$route.name==='Home'">
      <div>
        <p>
          <span>如果您要寄件</span>
          <span>点击右边的按钮登录后填写相关信息</span>
        </p>
        <button id="btn" @click="jump">立即寄件</button>
      </div>
    </div>
    <footer>
      <div class="footer-wrap">
        <div class="tidings">
          <div class="tidingsLeft">
            <dl class="wechat-code">
              <dt>
                <img :src="commonData?commonData.fastgoCode[0].logo_url:''" alt="">
              </dt>
              <dd>{{ commonData?commonData.fastgoCode[0].content:'' }}</dd>
            </dl>
            <!--<dl class="wechat-code">-->
              <!--<dt>-->
                <!--<img src="../assets/syd.png" alt="">-->
              <!--</dt>-->
              <!--<dd>悉尼专属客服</dd>-->
            <!--</dl>-->
            <dl class="service">
              <dt>
                <img src="../assets/kefu2.png" alt="">
              </dt>
              <dd>客服电话:<hr/>{{ commonData?commonData.tel[0].content:'' }}</dd>
            </dl>
          </div>
          <div class="tidingsRight">
            <p>客服微信号：<span v-for="(item,index) in commonData.service" :key="index">{{ item.content }} ; </span> </p>
            <p>(客服电话及客服微信号为人工答疑，不收身份证,周一~周五 8：00~17:00在线，非工作时间请留言)</p>
            <p>官方微信公众号：Fastgo速派快递（接受身份证图片，客服，查询）</p>
          </div>
          <div class="toPage">
            <router-link to="/AboutUs">关于我们</router-link>
            <router-link to="/ContactUs">联系我们</router-link>
            <div>网站地图-sitemap</div>
            <router-link to="/PageService">条款和条件</router-link>
            <div>隐私政策</div>
          </div>
        </div>
        <a href="https://beian.miit.gov.cn" target="_blank">
          <div class="region">
            <p>银高（上海）贸易有限公司</p>
            <img src="../assets/guohui.png" alt="">
            <p>沪ICP备</p>
            <p>14044046号-1</p>
          </div>
        </a>

      </div>
    </footer>
  </div>
</template>
<script>
    import { mapState } from 'vuex'
export default {

  name:'Footer',
  props:{

  },
  components:{

  },
  data(){
    return {

    }
  },
  computed:{
      ...mapState({
          commonData:state=>state.commonData,
      }),
  },
  methods:{
    jump(){
      console.log("window.innerHeight",window.innerHeight);
      document.documentElement.scrollTop = 300;
    }
  },
  created(){
    console.log('this',this.$route.name)
  },
  mounted(){
  }
}
</script>
<style scoped lang="scss">
.footer-wrapper {
  width: 100%;
  color: rgb(149,148,148);
}
.mailing {
  height: 100px;
  border-top: 3px solid $bg-color;
  div {
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      display: flex;
      flex-direction: column;
      span:nth-child(1) {
        font-size: 24px;
        color: $bg-color;
        font-weight: bolder;
      }
      span:nth-child(2) {
        font-size: 16px;
        color: #989797;
      }
    }
    button {
      width: 160px;
      height: 50px;
      color: #fff;
      background: $bg-color;
      font-size: 19px;
      border: none;
    }
  }
}
footer {
  background: #000;
  .footer-wrap {
    width: 1000px;
    margin: 0 auto;
    color: #8B8A8A;
    .tidings {
      height: 200px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      .tidingsLeft {
        display: flex;
        dl {
          margin: auto 0;
          text-align: center;
        }
        .wechat-code{
          margin-right: 10px;
          dt {
            img {
              width: 100px;
              height: 100px;
              margin: 0 auto;
            }
          }
        }
        .service {
          margin-left: 10px;
          dt {
            img {
              width: 40px;
              height: 50px;
            }
          }
          dd {
            text-align: center;
            height: 50px;
            margin-top: 8px;
            line-height: 30px;
          }
        }
      }
      .tidingsRight {
        font-size: 15px;
        width: 460px;
        margin: auto 0;
        word-break: break-all;
        /*text-align: right;*/
        p {
          margin: 8px 0;
        }
      }
    }
    .region{
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: underline;
      p {
        margin: 0 2px;
        font-size: 13px;
      }
    }
  }
}
.toPage{
  font-size: 13px;
  text-align: center;
  width: 120px;
  margin: auto 0;

}
  .toPage div,.toPage a{
    display: block;
    width: 100%;
    line-height: 30px;
    text-align: center;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue